import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import StatCard from "./StatCard";

import {
  Briefcase,
  Users,
  Upload,
  FileText,
  BookOpen,
  Settings,
  CheckCircle,
  FileUser,
  LaptopMinimal,
  Building,
} from "lucide-react";
import Utils from "../../../utils/Utils";
import WebUtils from "../../../utils/WebUtils";
import Loader from "../../Loader";
import cardImg from "../../../assets/orgAdmin/dashboard-img.svg";
import { getOrgAdminDashboard } from "../../../api/org-admin";

const statCards = (data) => [
  {
    title: "Total Batches",
    count: data?.totalBatches ?? 0,
    icon: <Briefcase size={50} />,
  },
  {
    title: "Total Students",
    count: data?.totalCandidates ?? 0,
    icon: <Users size={50} />,
  },
  {
    title: "Total JDs",
    count: data?.totalJdCreations ?? 0,
    icon: <FileText size={50} />,
  },
  {
    title: "Total Guides",
    count: data?.totalJobGuides ?? 0,
    icon: <BookOpen size={50} />,
  },
  {
    title: "Total Interviews Configured",
    count: data?.totalIDronaInterviewConfigured ?? 0,
    icon: <LaptopMinimal size={50} />,
  },

  {
    title: "Interviews Completed",
    count: data?.totalIDronaInterviewCompleted ?? 0,
    icon: <CheckCircle size={50} />,
  },
  {
    title: "Total Resumes",
    count: data?.totalCandidateResumeUploads ?? 0,
    icon: <FileUser size={50} />,
  },
];
const statsData = {
  organizationId: "ORG001",
  organizationName: "ABC Pvt Ltd",
  totalBatches: null,
  totalCandidateResumeUploads: null,
  totalIDronaInterviewConfigured: null,
  totalIDronaInterviewCompleted: null,
  totalJobGuides: null,
  totalCandidates: null,
  totalJdCreations: null,
};

function DashboardLandingPage() {
  const userDetail = Utils.getUserDetail();

  const [organizationAnalyticsData, setOrganizationAnalyticsData] =
    useState(null);
  const [loading, setLoading] = useState(false);

  const getOrgAnalytic = async () => {
    const url = `${getOrgAdminDashboard}?organizationId=${
      userDetail?.organizationId || null
    }`;

    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          let data = result.data.data;
          setOrganizationAnalyticsData(data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getOrgAnalytic();
  }, []);
  return (
    <>
      {loading && <Loader />}
      <div className="px-5 mt-4">
        <section className="w-full mx-auto dark-card text-white px-7 py-5 rounded-2xl">
          <div className="w-full m-auto flex flex-col-reverse lg:flex-row gap-4 justify-between items-center ">
            <div className="w-full lg:w-[60%] text-center lg:text-left">
              <p className="text-[1.6rem] xl:text-[1.875rem] font-semibold leading-[2rem] xl:leading-[2.3rem] text-[#EDC043]">
                Empower Your Students to Succeed in Every Interview{" "}
              </p>
              <p className="pt-[1.05rem] text-[0.875rem] xl:text-[0.98rem] font-medium leading-[1.52rem] ">
                Track student progress, manage mock interviews, assign
                preparation guides, and gain actionable insights to help
                learners become job-ready with confidence.
              </p>
              <div className="flex items-center gap-2 mt-4">
                <span className="">
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 9H16.8C17.9201 9 18.4802 9 18.908 9.21799C19.2843 9.40973 19.5903 9.71569 19.782 10.092C20 10.5198 20 11.0799 20 12.2V19M12 19V4.2C12 3.0799 12 2.51984 11.782 2.09202C11.5903 1.71569 11.2843 1.40973 10.908 1.21799C10.4802 1 9.9201 1 8.8 1H5.2C4.0799 1 3.51984 1 3.09202 1.21799C2.71569 1.40973 2.40973 1.71569 2.21799 2.09202C2 2.51984 2 3.0799 2 4.2V19M21 19H1M5.5 5H8.5M5.5 9H8.5M5.5 13H8.5"
                      stroke="#EDC043"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
                <span>
                  <span className="text-lg font-semibold break-all">
                    {organizationAnalyticsData?.organizationName}
                  </span>
                  {" "}
                  <span className="text-[.8rem]">({organizationAnalyticsData?.organizationId})</span>
                </span>
              </div>
              <div className="mt-[1rem] xl:mt-[1.5rem] flex flex-col lg:flex-row gap-3">
                <Link to="/org-admin/mock-interviews">
                  <button className="btn-grey driver-review-account hover-effect text-white w-full md:w-[60%] lg:w-full text-[0.85rem] py-[9px] px-[1.2rem]">
                    Manage Interviews
                  </button>
                </Link>
                <Link to="/org-admin/batches">
                  <button className="btn-orange driver-performance-insights w-full hover-effect md:w-[60%] lg:w-full text-[0.85rem] py-[9px] px-[1.2rem] text-[#212529]">
                    Manage Batches
                  </button>
                </Link>
              </div>
            </div>
            <div className="w-full lg:w-[40%] flex lg:justify-end justify-center items-center">
              <img src={cardImg} />
            </div>
          </div>
        </section>

        <div className="mt-6">
          <div className="grid grid-cols-1 lg:grid-cols-3 sm:grid-cols-2 xl:grid-cols-4 gap-5">
            {statCards(organizationAnalyticsData)?.map((item, index) => (
              <StatCard
                key={index}
                title={item.title}
                count={item.count}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default DashboardLandingPage;
